import Vue from 'vue'
import Murmur from '@icij/murmur'
import IframeResizer from '@icij/murmur/lib/utils/iframe-resizer'

import App from './App.vue'
import router from './router'

import '@/main.scss'

Vue.config.productionTip = false

Murmur.config.set('app.name', 'Graphics')
Murmur.config.set('app.home', 'https://www.icij.org/investigations/implant-files/')
Murmur.config.set('sharing-options.title', 'Have you seen this data from the Implant Files?')
Murmur.config.set('sharing-options.description', 'The Implant Files is a year-long investigation into the harm caused by medical devices around the world')
Murmur.config.set('project.name', 'The Implant Files')
Murmur.config.set('signup-form.tracker', 'GRAPHICS')
Murmur.config.set('main-header.dropdown.items', [
  { label: 'About this investigation', href: 'https://www.icij.org/investigations/implant-files/about-the-implant-files-investigation', target: '_blank' },
  { label: Murmur.config.get('app.name'), href: 'https://medicaldevices.icij.org' },
  { label: 'Tell us your story', href: 'https://www.icij.org/investigations/implant-files/do-events-in-the-implant-files-sound-familiar-share-your-story-with-the-world', target: '_blank' },
  { label: 'Resources for patients', href: 'https://www.icij.org/investigations/implant-files/resources-for-patients-and-frequently-asked-questions/', target: '_blank' },
  { label: 'Reporting partners', href: 'https://www.icij.org/investigations/implant-files/implant-files-reporting-partners/', target: '_blank'  },
  { label: 'Video introduction', href: 'https://www.icij.org/investigations/implant-files/video-a-global-investigation-into-medical-device-harm/', target: '_blank'  }
])

// Embedded mode (with Pym)
IframeResizer.create()

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
